import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import Helmet from "react-helmet";
import ErrorMessage from "../../components/ErrorMessage";
import {config} from "../../components/Constants";
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class LogsList extends React.Component {
  constructor (props) {
    super(props);
    let year = this.props.match.params.year;
    if(!year){
      year = new Date().getFullYear();
    }
    this.state = {
      error: null,
      isLoaded: false,
      isLoggedIn: false,
      isSearching: false,
      year: year,
      clients: []
    };
  }

  componentDidMount () {
    fetch(config.API_URL + '/api/logs/' + this.state.year, {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(
        (result) => {
          if (result.error) {
            this.setState({
              clients: [],
              isLoaded: true,
              error: result.error
            });
          } else if (result) {
            this.setState({
              clients: result.clients,
              isLoaded: true
            });
          }
        },
        (error) => {
          this.setState({
            clients: [],
            isLoaded: true,
            error: error
          });
        }
      )
  }

  maxWeeksInYear (year) {
    const currentDate = new Date(year, 11, 31);
    const startDate = new Date(year, 0, 1);
    var days = Math.floor((currentDate - startDate) /
      (24 * 60 * 60 * 1000));

    return Math.ceil(days / 7)
  }

  prepareDataSet(clients, maxWeeks){
    let sum_col = {suml: 0, summ: 0, sume: 0, sumu: 0};
    let dataSet = [];
     clients.map((client, mkey) => {
      let row = {
        id: client.id,
        url: 'https://' + client.subd + '.sim.horecaidea.pl/',
        subd: client.subd,
        name: client.nazwa,
      };
      let suml = 0;
      let summ = 0;
      let sume = 0;
      maxWeeks.map((object, i) => {
        suml += client.logs[i].login;
        summ += client.logs[i].loginMobi;
        sume += client.logs[i].eventsCreated;
        if (typeof sum_col[i] === "undefined") {
          sum_col[i] = {
            login: 0,
            loginMobi: 0,
            eventsCreated: 0,
          };
        }
        row['login'+i] = client.logs[i].login;
        row['loginMobi'+i] = client.logs[i].loginMobi;
        row['eventsCreated'+i] = client.logs[i].eventsCreated;
        sum_col[i].login += client.logs[i].login;
        sum_col[i].loginMobi += client.logs[i].loginMobi;
        sum_col[i].eventsCreated += client.logs[i].eventsCreated;
        sum_col.suml += client.logs[i].login;
        sum_col.summ += client.logs[i].loginMobi;
        sum_col.sume += client.logs[i].eventsCreated;
      });
      row.suml=suml;
      row.summ=summ;
      row.sume=sume;
      row.activeUsers=client.activeUsers;
      dataSet.push(row);
    });
    return dataSet;
  }

  render () {
    const {error, isLoaded, isLoggedIn, clients, isSearching, year} = this.state;
    const that = this;
    if (!isLoaded) {
      return (
        <LoadingSpin/>
      );
    } else if (error) {
      return (
        <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
          {
            'title': 'Powrót', 'callback': function () {
              that.setState({redirect: '/clients', error: null});
            }
          }
        ]} handleClose={() => {
          that.setState({redirect: '/clients', error: null});
        }}/>
      );
    } else {
      const maxWeeksNo = this.maxWeeksInYear(year);
      const maxWeeks = Array.apply(null, Array(maxWeeksNo)).map(function (x, i) { return i+1; })
      let sum_col = {suml: 0, summ: 0, sume: 0, sumu: 0};
      let dataSet = this.prepareDataSet(clients, maxWeeks);
      console.log(dataSet);
      return (
        <React.Fragment>
          <Helmet>
            <title>Logi logowań</title>
          </Helmet>
          <header className="clients-header">
            <h1>Logi logowań {year}</h1>
            <ExcelFile element={<button className={'btn btn-primary'}>Pobierz Excel</button>}>
              <ExcelSheet data={dataSet} name="Logowania">
                <ExcelColumn label="ID" value="id"/>
                <ExcelColumn label="Adres URL" value="url"/>
                <ExcelColumn label="Subdomena" value="subd"/>
                <ExcelColumn label="Obiekt" value="name"/>
                {maxWeeks.map((object, i) => {
                  return (
                    <ExcelColumn label={'L '+i} value={'login'+i}/>
                  )
                })
                }
                {maxWeeks.map((object, i) => {
                  return (
                    <ExcelColumn label={'M '+i} value={'loginMobi'+i}/>
                  )
                })
                }
                {maxWeeks.map((object, i) => {
                  return (
                    <ExcelColumn label={'W '+i} value={'eventsCreated'+i}/>
                  )
                })
                }
                <ExcelColumn label="Suma L" value="suml"/>
                <ExcelColumn label="Suma M" value="summ"/>
                <ExcelColumn label="Suma W" value="sume"/>
                <ExcelColumn label="Aktywni Użytkownicy" value="activeUsers"/>
              </ExcelSheet>
            </ExcelFile>
          </header>
          <div className="section-div">
            {!isSearching ?
              <table className="data" id="table-to-xls">
                <thead id="tableHead">
                <tr>
                  <th className="center fix" rowSpan={3}>ID</th>
                  <th rowSpan={3}>Subdomena</th>
                  <th rowSpan={3}>Nazwa obiektu</th>
                  <th className="center" colSpan={maxWeeksNo * 3}>Tydzień</th>
                  <th className="center th-sum" rowSpan={2} colSpan={3}>Suma</th>
                  <th rowSpan={3}>Aktywni użytkownicy</th>
                </tr>
                <tr>
                  {maxWeeks.map((object, i) => {
                    return (
                      <th className="center" colSpan={3}>
                        {i+1}
                      </th>
                    )
                  })
                  }
                </tr>
                <tr>
                  {maxWeeks.map((object, i) => {
                    return (
                      <React.Fragment>
                        <th className="center">
                          L
                        </th>
                        <th className="center">
                          M
                        </th>
                        <th className="center">
                          W
                        </th>
                      </React.Fragment>
                    )
                  })
                  }
                  <th className="center th-sum">
                    L
                  </th>
                  <th className="center th-sum">
                    M
                  </th>
                  <th className="center th-sum">
                    W
                  </th>
                </tr>
                </thead>
                <tbody>
                {clients ? clients.map((client, mkey) => {
                    let suml = 0;
                    let summ = 0;
                    let sume = 0;
                    sum_col.sumu+=client.activeUsers;

                    return (
                      <tr key={mkey}>
                        <td className="center fix">{client.id}</td>
                        <td className="fix"><a href={'https://' + client.subd + '.sim.horecaidea.pl/'} target="_blank">{client.subd}</a></td>
                        <td className="fix">{client.nazwa}</td>
                        {maxWeeks.map((object, i) => {
                          suml+=client.logs[i].login;
                          summ+=client.logs[i].loginMobi;
                          sume+=client.logs[i].eventsCreated;
                          if(typeof sum_col[i] === "undefined"){
                            sum_col[i] = {
                              login: 0,
                              loginMobi: 0,
                              eventsCreated: 0,
                            };
                          }
                          sum_col[i].login+=client.logs[i].login;
                          sum_col[i].loginMobi+=client.logs[i].loginMobi;
                          sum_col[i].eventsCreated+=client.logs[i].eventsCreated;
                          sum_col.suml+=client.logs[i].login;
                          sum_col.summ+=client.logs[i].loginMobi;
                          sum_col.sume+=client.logs[i].eventsCreated;
                          return (
                            <React.Fragment>
                              <td className="center" className={'bg-'+(i%2)}>
                                {client.logs[i].login}
                              </td>
                              <td className="center" className={'bg-'+(i%2)}>
                                {client.logs[i].loginMobi}
                              </td>
                              <td className="center" className={'bg-'+(i%2)}>
                                {client.logs[i].eventsCreated}
                              </td>
                            </React.Fragment>
                          )
                        })
                        }
                        <React.Fragment>
                          <td className="center" className={'bg-sum'}>
                            {suml}
                          </td>
                          <td className="center" className={'bg-sum'}>
                            {summ}
                          </td>
                          <td className="center" className={'bg-sum'}>
                            {sume}
                          </td>
                          <td className="center bg-sum">{client.activeUsers}</td>
                        </React.Fragment>
                      </tr>
                    )
                  }) :
                  <tr>
                    <td colSpan={13}>
                      Brak załadowanych obiektów
                    </td>
                  </tr>
                }
                </tbody>
                <tfoot>
                  <tr>
                    <th colSpan={3}>
                      Suma
                    </th>
                    {maxWeeks.map((object, i) => {
                      return (
                        <React.Fragment>
                          <th className="center">
                            {sum_col[i].login}
                          </th>
                          <th className="center">
                            {sum_col[i].loginMobi}
                          </th>
                          <th className="center">
                            {sum_col[i].eventsCreated}
                          </th>
                        </React.Fragment>
                      )
                    })
                    }
                    <th className="center">
                      {sum_col.suml}
                    </th>
                    <th className="center">
                      {sum_col.summ}
                    </th>
                    <th className="center">
                      {sum_col.sume}
                    </th>
                    <th className="center">
                      {sum_col.sumu}
                    </th>
                  </tr>
                </tfoot>
              </table>
              : <LoadingSpin/>}
          </div>
        </React.Fragment>
      );
    }
  }
}

export default LogsList;

